import { StringToStringMap } from '@/interfaces/global'
import i18n from '@/locales'

export function importColumnTitlesList() {
  return [
    i18n.global.t('itemAlt') as string,
    i18n.global.t('partNumber') as string,
    i18n.global.t('quantity') as string,
    i18n.global.t('uom') as string,
    i18n.global.tc('supplier', 1),
    i18n.global.t('retailPrice') as string,
    i18n.global.t('wholesalePrice') as string,
    i18n.global.t('discountPrice') as string,
    i18n.global.t('partOrderable') as string,
    i18n.global.t('pagePartOrderable') as string,
    i18n.global.t('partNumberVisible') as string,
    i18n.global.t('pagePartNumberVisible') as string,
    i18n.global.t('arabicEgyptName') as string,
    i18n.global.t('arabicEgyptDescription') as string,
    i18n.global.t('englishName') as string,
    i18n.global.t('englishDescription') as string,
    i18n.global.t('englishGBName') as string,
    i18n.global.t('englishGBDescription') as string,
    i18n.global.t('bahasaName') as string,
    i18n.global.t('bahasaDescription') as string,
    i18n.global.t('chineseName') as string,
    i18n.global.t('chineseDescription') as string,
    i18n.global.t('chineseTaiwanName') as string,
    i18n.global.t('chineseTaiwanDescription') as string,
    i18n.global.t('czechName') as string,
    i18n.global.t('czechDescription')  as string,
    i18n.global.t('danishName') as string,
    i18n.global.t('danishDescription')  as string,
    i18n.global.t('dutchName') as string,
    i18n.global.t('dutchDescription')  as string,
    i18n.global.t('estonianName') as string,
    i18n.global.t('estonianDescription')  as string,
    i18n.global.t('finnishName') as string,
    i18n.global.t('finnishDescription')  as string,
    i18n.global.t('frenchName') as string,
    i18n.global.t('frenchDescription') as string,
    i18n.global.t('frenchCanadianName') as string,
    i18n.global.t('frenchCanadianDescription') as string,
    i18n.global.t('germanName') as string,
    i18n.global.t('germanDescription') as string,
    i18n.global.t('greekName') as string,
    i18n.global.t('greekDescription') as string,
    i18n.global.t('hungarianName') as string,
    i18n.global.t('hungarianDescription')  as string,
    i18n.global.t('italianName') as string,
    i18n.global.t('italianDescription')  as string,
    i18n.global.t('japaneseName') as string,
    i18n.global.t('japaneseDescription') as string,
    i18n.global.t('koreanName') as string,
    i18n.global.t('koreanDescription') as string,
    i18n.global.t('hebrewName') as string,
    i18n.global.t('hebrewDescription') as string,
    i18n.global.t('hindiName') as string,
    i18n.global.t('hindiDescription') as string,
    i18n.global.t('croatianName') as string,
    i18n.global.t('croatianDescription') as string,
    i18n.global.t('bosnianName') as string,
    i18n.global.t('bosnianDescription') as string,
    i18n.global.t('armenianName') as string,
    i18n.global.t('armenianDescription') as string,
    i18n.global.t('indonesianName') as string,
    i18n.global.t('indonesianDescription') as string,
    i18n.global.t('icelandicName') as string,
    i18n.global.t('icelandicDescription') as string,
    i18n.global.t('latvianName') as string,
    i18n.global.t('latvianDescription') as string,
    i18n.global.t('lithuanianName') as string,
    i18n.global.t('lithuanianDescription') as string,
    i18n.global.t('macedonianName') as string,
    i18n.global.t('macedonianDescription') as string,
    i18n.global.t('mongolianName') as string,
    i18n.global.t('mongolianDescription') as string,
    i18n.global.t('dutchName') as string,
    i18n.global.t('dutchDescription')  as string,
    i18n.global.t('norwegianName') as string,
    i18n.global.t('norwegianDescription')  as string,
    i18n.global.t('polishName') as string,
    i18n.global.t('polishDescription') as string,
    i18n.global.t('portugueseName') as string,
    i18n.global.t('portugueseDescription') as string,
    i18n.global.t('portugueseBrazilName') as string,
    i18n.global.t('portugueseBrazilDescription') as string,
    i18n.global.t('romanianName') as string,
    i18n.global.t('romanianDescription')  as string,
    i18n.global.t('russianName') as string,
    i18n.global.t('russianDescription') as string,
    i18n.global.t('serbianName') as string,
    i18n.global.t('serbianDescription')  as string,
    i18n.global.t('slovenianName') as string,
    i18n.global.t('slovenianDescription') as string,
    i18n.global.t('slovakName') as string,
    i18n.global.t('slovakDescription') as string,
    i18n.global.t('swedishName') as string,
    i18n.global.t('swedishDescription') as string,
    i18n.global.t('spanishName') as string,
    i18n.global.t('spanishDescription') as string,
    i18n.global.t('spanishChileName') as string,
    i18n.global.t('spanishChileDescription') as string,
    i18n.global.t('spanishMexicoName') as string,
    i18n.global.t('spanishMexicoDescription') as string,
    i18n.global.t('thaiName') as string,
    i18n.global.t('thaiDescription')  as string,
    i18n.global.t('papuaNewGuineaName') as string,
    i18n.global.t('papuaNewGuineaDescription')  as string,
    i18n.global.t('turkishName') as string,
    i18n.global.t('turkishDescription')  as string,
    i18n.global.t('ukraineName') as string,
    i18n.global.t('ukraineDescription')  as string,
  ]
}

export function importColumnTitlesMap() {
    const list = importColumnTitlesList()
    const map: StringToStringMap = {}
    list.forEach(it => {
        map[it] = it
    })
    return map
}

export function getImportColumnsToBomItems() {
  return {
    [i18n.global.t('itemAlt') as string]: 'item',
    [i18n.global.t('partNumber') as string]: 'partNumber',
    [i18n.global.t('quantity') as string]: 'quantity',
    [i18n.global.t('uom') as string]: 'unitOfMeasure',
    [i18n.global.tc('supplier', 1)]: 'supplier',
    [i18n.global.t('retailPrice') as string]: 'retailPrice',
    [i18n.global.t('wholesalePrice') as string]: 'wholesalePrice',
    [i18n.global.t('discountPrice') as string]: 'discountedPrice',
    [i18n.global.t('partOrderable') as string]: 'orderableForPart',
    [i18n.global.t('pagePartOrderable') as string]: 'orderableForPagePart',
    [i18n.global.t('partNumberVisible') as string]: 'partNumberVisibleForPart',
    [i18n.global.t('pagePartNumberVisible') as string]: 'partNumberVisibleForPagePart'
  }
}


export function getTrNamesToTrCodes() {
  return {
    [i18n.global.t('englishName') as string]: 'en-US',
    [i18n.global.t('englishGBName') as string]: 'en-GB',
    [i18n.global.t('arabicEgyptName') as string]: 'ar-EG',
    [i18n.global.t('danishName') as string]: 'da-DK',
    [i18n.global.t('bahasaName') as string]: 'id-ID',
    [i18n.global.t('czechName') as string]: 'cs-CZ',
    [i18n.global.t('spanishName') as string]: 'es-ES',
    [i18n.global.t('spanishChileName') as string]: 'es-CL',
    [i18n.global.t('spanishMexicoName') as string]: 'es-MX',
    [i18n.global.t('estonianName') as string]: 'et-EE',
    [i18n.global.t('finnishName') as string]: 'fi-FI',
    [i18n.global.t('frenchName') as string]: 'fr-FR',
    [i18n.global.t('frenchCanadianName') as string]: 'fr-CA',
    [i18n.global.t('germanName') as string]: 'de-DE',
    [i18n.global.t('greekName') as string]: 'el-GR',
    [i18n.global.t('hebrewName') as string]: 'he-IL',
    [i18n.global.t('hindiName') as string]: 'hi-IN',
    [i18n.global.t('croatianName') as string]: 'hr-HR',
    [i18n.global.t('bosnianName') as string]: 'bs-BA',
    [i18n.global.t('hungarianName') as string]: 'hu-HU',
    [i18n.global.t('armenianName')  as string]: 'hy-AM',
    [i18n.global.t('indonesianName') as string]: 'id-ID',
    [i18n.global.t('icelandicName')  as string]: 'is-IS',
    [i18n.global.t('italianName') as string]: 'it-IT',
    [i18n.global.t('japaneseName') as string]: 'ja-JP',
    [i18n.global.t('koreanName') as string]: 'ko-KR',
    [i18n.global.t('latvianName') as string]: 'lv-LV',
    [i18n.global.t('lithuanianName') as string]: 'lt-LT',
    [i18n.global.t('macedonianName') as string]: 'mk-MK',
    [i18n.global.t('mongolianName') as string]: 'mn-MN',
    [i18n.global.t('dutchName') as string]: 'nl-NL',
    [i18n.global.t('norwegianName') as string]: 'no-NO',
    [i18n.global.t('polishName') as string]: 'pl-PL',
    [i18n.global.t('portugueseBrazilName') as string]: 'pt-BR',
    [i18n.global.t('portugueseName') as string]: 'pt-PT',
    [i18n.global.t('romanianName') as string]: 'ro-RO',
    [i18n.global.t('russianName') as string]: 'ru-RU',
    [i18n.global.t('serbianName') as string]: 'sr-RS',
    [i18n.global.t('slovakName') as string]: 'sk-SK',
    [i18n.global.t('slovenianName') as string]: 'sl-SI',
    [i18n.global.t('swedishName') as string]: 'sv-SE',
    [i18n.global.t('thaiName') as string]: 'th-TH',
    [i18n.global.t('papuaNewGuineaName') as string]: 'tpi-PG',
    [i18n.global.t('turkishName') as string]: 'tr-TR',
    [i18n.global.t('ukraineName') as string]: 'uk-UA',
    [i18n.global.t('chineseName') as string]: 'zh-CN',
    [i18n.global.t('chineseTaiwanName') as string]: 'zh-TW'
  }
}

export function getTrDescToTrCodes() {
  return {
    [i18n.global.t('englishDescription') as string]: 'en-US',
    [i18n.global.t('englishGBDescription') as string]: 'en-GB',
    [i18n.global.t('arabicEgyptDescription') as string]: 'ar-EG',
    [i18n.global.t('danishDescription') as string]: 'da-DK',
    [i18n.global.t('greekDescription') as string]: 'el-GR',
    [i18n.global.t('bahasaDescription') as string]: 'id-ID',
    [i18n.global.t('czechDescription')  as string]: 'cs-CZ',
    [i18n.global.t('spanishDescription') as string]: 'es-ES',
    [i18n.global.t('spanishChileDescription') as string]: 'es-CL',
    [i18n.global.t('spanishMexicoDescription') as string]: 'es-MX',
    [i18n.global.t('estonianDescription') as string]: 'et-EE',
    [i18n.global.t('finnishDescription')  as string]: 'fi-FI',
    [i18n.global.t('frenchCanadianDescription') as string]: 'fr-CA',
    [i18n.global.t('frenchDescription') as string]: 'fr-FR',
    [i18n.global.t('germanDescription') as string]: 'de-DE',
    [i18n.global.t('hebrewDescription') as string]: 'he-IL',
    [i18n.global.t('hindiDescription') as string]: 'hi-IN',
    [i18n.global.t('croatianDescription') as string]: 'hr-HR',
    [i18n.global.t('bosnianDescription') as string]: 'bs-BA',
    [i18n.global.t('hungarianDescription')  as string]: 'hu-HU',
    [i18n.global.t('armenianDescription')  as string]: 'hy-AM',
    [i18n.global.t('indonesianDescription') as string]: 'id-ID',
    [i18n.global.t('icelandicDescription')  as string]: 'is-IS',
    [i18n.global.t('italianDescription')  as string]: 'it-IT',
    [i18n.global.t('japaneseDescription') as string]: 'ja-JP',
    [i18n.global.t('latvianDescription') as string]: 'lv-LV',
    [i18n.global.t('lithuanianDescription') as string]: 'lt-LT',
    [i18n.global.t('koreanDescription') as string]: 'ko-KR',
    [i18n.global.t('macedonianDescription') as string]: 'mk-MK',
    [i18n.global.t('mongolianDescription') as string]: 'mn-MN',
    [i18n.global.t('dutchDescription')  as string]: 'nl-NL',
    [i18n.global.t('norwegianDescription') as string]: 'no-NO',
    [i18n.global.t('polishDescription') as string]: 'pl-PL',
    [i18n.global.t('portugueseDescription') as string]: 'pt-PT',
    [i18n.global.t('portugueseBrazilDescription') as string]: 'pt-BR',
    [i18n.global.t('romanianDescription') as string]: 'ro-RO',
    [i18n.global.t('russianDescription') as string]: 'ru-RU',
    [i18n.global.t('serbianDescription') as string]: 'sr-RS',
    [i18n.global.t('slovakDescription') as string]: 'sk-SK',
    [i18n.global.t('slovenianDescription') as string]: 'sl-SI',
    [i18n.global.t('swedishDescription') as string]: 'sv-SE',
    [i18n.global.t('thaiDescription') as string]: 'th-TH',
    [i18n.global.t('papuaNewGuineaDescription') as string]: 'tpi-PG',
    [i18n.global.t('turkishDescription') as string]: 'tr-TR',
    [i18n.global.t('ukraineDescription') as string]: 'uk-UA',
    [i18n.global.t('chineseDescription') as string]: 'zh-CN',
    [i18n.global.t('chineseTaiwanDescription') as string]: 'zh-TW'
  }
}


export function getTrCodesToNamesMap() {
  const namesToCodes = getTrNamesToTrCodes()
  const map: StringToStringMap = {}
  for (let key in namesToCodes) {
    const value = namesToCodes[key]
    map[value] = key
  }
  return map
}

export function getTrCodesToDescMap() {
  const descToCodes = getTrDescToTrCodes()
  const map: StringToStringMap = {}
  for (let key in descToCodes) {
    const value = descToCodes[key]
    map[value] = key
  }
  return map
}
